module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pz17-2"
    }
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "images/img-17-1.jpg",
      "id": "z17-2",
      "src": "images/img-17-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pz17-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch1"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch1"
    }
  }, [_vm._v("\n\t\t\t\t\tOut of Nothing, Something")])]), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "AYtM"
    }
  }, [_vm._v("\n\t\t\t\t\t2002 11.1 Spring ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "pz17-5"
    }
  }, [_c('i', [_vm._v("zero [Fr. zero <It. zero < Ar. sifr, cipher] the symbol or numeral 0, nothing,\n\t\t\t\t\tthe lowest point, without measurable value.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "pz17-7"
    }
  }, [_c('i', [_vm._v("cipher [ME. cifre < OFr. cyfre <ML. cifra < Ar. sifr, a cipher, nothing\n\t\t\t\t\t< safara, to be empty] zero, a person of no importance or value, a nonentity,\n\t\t\t\t\ta system of secret writing based on a key, or set of predetermined rules or symbols,\n\t\t\t\t\tto use secret writing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "pz17-8"
    }
  }, [_vm._v("\n\t\t\t\t\tLast week, I went to the library, hardly expecting to find a book to read which would\n\t\t\t\t\tchange the way I viewed the world. "), _c('i', [_vm._v("The Universal History of Numbers")]), _vm._v(" by Georges Ifrah\n\t\t\t\t\t(ISBN 0-471-375683) did just that. This one volume, encyclopedic in scope and filled\n\t\t\t\t\twith history, philosophy, and wisdom, demonstrates how our western civilization learned\n\t\t\t\t\tto count and what to count. This wonderful book shows us a mirror, reflecting our\n\t\t\t\t\thuman brilliance and ridiculousness. When I finished, I laid the text down and could\n\t\t\t\t\tnot decide whether to bask in the glow of mankind’s intelligence or hide in the dark,\n\t\t\t\t\tso as not to be discovered for what fools humans often are. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-9"
    }
  }, [_vm._v("\n\t\t\t\t\tWhere do you think our numbers came from? Did the Arabs invent the Arabic numbers\n\t\t\t\t\tthat we use now? When did Europeans quit counting with Roman numerals? Why were people\n\t\t\t\t\tburned alive at the stake for using zeroes in their arithmetic? In the middle ages,\n\t\t\t\t\twhy was a person of no account called a “cipher”? What do the Devil and Pope Sylvester\n\t\t\t\t\tII of the Roman Catholic Church have to do with the way we count hamburgers at Burger\n\t\t\t\t\tKing? Why did Montaigne, the Frenchman who developed the genre of essay writing,\n\t\t\t\t\t"), _c('span', {
    attrs: {
      "id": "z18-1"
    }
  }, [_vm._v("say he was embarrassed to admit that he never learned to count or do mathematics?\n\t\t\t\t\tWho was Gerbert of Aurillac, and why should we thank him every time we count our\n\t\t\t\t\tfingers and toes? ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-2"
    }
  }, [_vm._v("\n\t\t\t\t\tI don’t consider myself a mathematician, never have and never will. I can balance\n\t\t\t\t\tmy checkbook, when there is money in it, but do not ask me how many zeroes there\n\t\t\t\t\tare in one quadrillion. I am just grateful to have nine numbers and a zero to play\n\t\t\t\t\twith before April 15, each year. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-3"
    }
  }, [_vm._v("\n\t\t\t\t\tEuropeans must have felt something like this in the fifteenth century, too. They\n\t\t\t\t\tthought any French or German university would suffice if the student wanted to learn\n\t\t\t\t\taddition or subtraction, but if the student wanted to learn multiplication and division,\n\t\t\t\t\tonly an Italian university would do. Arithmetic was “an obscure and complex art,”\n\t\t\t\t\tand if one wanted to have as much knowledge as the average high school senior of\n\t\t\t\t\ttoday, then the serious student of the 1400s would need to acquire a PhD. Because\n\t\t\t\t\tso few people in any European country knew how to use numbers, a specialist was required,\n\t\t\t\t\tand it would take him several hours to perform a multiplication which a student today\n\t\t\t\t\tcan do in a few minutes. It is little wonder that skilled abacists were thought to\n\t\t\t\t\thave supernatural powers. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-4"
    }
  }, [_vm._v("\n\t\t\t\t\tSamuel Pepys graduated from Cambridge University in England, became a civil servant,\n\t\t\t\t\tand later worked for the Admiralty where he was in charge of naval procurement in\n\t\t\t\t\t1662. Although he was highly educated for his day, he could not perform the calculations\n\t\t\t\t\tfor the purchases of timber made by his office. Eventually, he did learn, with the\n\t\t\t\t\thelp of a tutor, and was so proud of himself that he tried to teach his wife addition,\n\t\t\t\t\tsubtraction, and multiplication, but he knew better than to try to teach her long\n\t\t\t\t\tdivision. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-5"
    }
  }, [_vm._v("\n\t\t\t\t\tGerbert of Aurillac (France) was a Catholic priest and “one of the most prominent\n\t\t\t\t\tscientific personalities” of the Middle Ages. He was born in 945 CE and spent his\n\t\t\t\t\twhole life in the church. Eventually, he became adviser to Pope Gregory V, Archbishop\n\t\t\t\t\tof Reims, Archbishop of Ravenna, and finally, Pope Sylvester II, from 999 until his\n\t\t\t\t\tdeath in 1003. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-6"
    }
  }, [_vm._v("\n\t\t\t\t\tWhen Gerbert was a young monk with a thirst for knowledge, his brilliant mind absorbed\n\t\t\t\t\tlessons from the Arabic schools he attended in Spain, and he disguised himself as\n\t\t\t\t\ta Muslim pilgrim to enter Arab universities. When he returned to France, he brought\n\t\t\t\t\twith him the techniques of modern arithmetic and was the first person to introduce\n\t\t\t\t\tArabic numerals to Europe. It would take several centuries for Europe "), _c('span', {
    attrs: {
      "id": "z19-1"
    }
  }, [_vm._v("to accept the\n\t\t\t\t\tfirst nine numerals and several more centuries to use the zero. The Roman past was\n\t\t\t\t\tso admired throughout Europe that the people could not accept any other numbering\n\t\t\t\t\tsystem. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-2"
    }
  }, [_vm._v("\n\t\t\t\t\tGerbert’s bishop said the zero was too easy to use and was sent from the Devil, so\n\t\t\t\t\tfor their own protection, it could not be used by the common people. Mysticism, sin,\n\t\t\t\t\thell, salvation, philosophy, and religious dogma were all under ecclesiastical control,\n\t\t\t\t\twhich served to restrict intellectual liberation for centuries. The Arabic numbers,\n\t\t\t\t\tbecause they were so easy to use, “reeked of magic and the diabolical.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-3"
    }
  }, [_vm._v("\n\t\t\t\t\tThis French monk was labeled an alchemist and a sorcerer who sold his soul to Lucifer\n\t\t\t\t\twhen he visited the Saracens. In 1648, papal authorities reopened Pope Sylvester’s\n\t\t\t\t\ttomb (645 years after his death) to see if it was still possessed by the Devil, because\n\t\t\t\t\the brought back the Arabic numbers. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-4"
    }
  }, [_vm._v("\n\t\t\t\t\tAlthough the Crusades did not accomplish for the Christians what was intended, defeating\n\t\t\t\t\tthe Muslims, several surprising things benefiting Europe were achieved when they\n\t\t\t\t\treached the walls of Jerusalem. Because so many clerks traveling with the armies\n\t\t\t\t\tcame in contact with Arabic arithmetical methods, Gerbert’s numerals were finally\n\t\t\t\t\tassimilated into regular accounting practices. Europeans could not impose their religion\n\t\t\t\t\ton the Middle East by force, but the Arabs finally taught the Europeans how to count\n\t\t\t\t\tquickly, accurately, and successfully, using the tradition they learned from the\n\t\t\t\t\tIndians more than a thousand years before. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-5"
    }
  }, [_vm._v("\n\t\t\t\t\tA sleepy-acting senior startled me one day in class, when he suddenly sat up in his\n\t\t\t\t\tseat and said loudly, “The only thing anyone needs to find wisdom is an open mind.”\n\t\t\t\t\tGerbert of Aurillac would have understood, precisely. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 72
// module chunks = 0